var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 850 331",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21V306.686C1 308.808 1.84285 310.843 3.34314 312.343L19.2426 328.243C20.3679 329.368 21.894 330 23.4853 330H673.849C675.822 330 677.669 329.03 678.789 327.406L685.211 318.094C686.331 316.47 688.178 315.5 690.151 315.5H829C834.523 315.5 839 311.023 839 305.5V157.985C839 156.394 839.632 154.868 840.757 153.743L847.243 147.257C848.368 146.132 849 144.606 849 143.015V21L831.929 3.92893C830.054 2.05357 827.565 1 824.913 1H248H188.428C187.07 1 185.805 1.68906 185.068 2.8299L179.682 11.1701C178.945 12.3109 177.68 13 176.322 13H9C4.58172 13 1 16.5817 1 21Z",
    fill: "#121212",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.474 9L144 9L151.526 0.999999L157 0.999999L149.474 9Z",
    fill: "#646464"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.474 8.99999L9 9L9 8L47.9408 8L54.5263 0.999996L149 0.999988L141.474 8.99999Z",
    fill: "#646464"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.474 9L152 9L159.526 0.999999L165 0.999999L157.474 9Z",
    fill: "#646464"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.474 9L160 9L167.526 0.999999L173 0.999999L165.474 9Z",
    fill: "#646464"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.474 9L168 9L175.526 0.999999L181 0.999999L173.474 9Z",
    fill: "#646464"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M718.526 322L724 322L716.474 330L711 330L718.526 322Z",
    fill: "#646464"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M726.526 322L830 322L830 323L762.059 323L755.474 330L719 330L726.526 322Z",
    fill: "#646464"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M710.526 322L716 322L708.474 330L703 330L710.526 322Z",
    fill: "#646464"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M702.526 322L708 322L700.474 330L695 330L702.526 322Z",
    fill: "#646464"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M694.526 322L700 322L692.474 330L687 330L694.526 322Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFrame);
export default __webpack_public_path__ + "static/media/profileFrame.4bc851fe04d7f4d331e124b58655143b.svg";
export { ForwardRef as ReactComponent };